import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import SwipeableViews from 'react-swipeable-views';
import FlatButton from 'material-ui/FlatButton';
import Slider from 'react-slick';

import { saveOnboard } from '../../store/modules/login';
import { runJoyride } from '../../store/modules/options';
import mergeStates from '../../helpers/mergeStates';

import classes from './OnboardingDialog.scss';

import onboardingImage1 from '../../styles/assets/onboarding-1.svg';
import onboardingImage2 from '../../styles/assets/onboarding-2.svg';
import onboardingImage3 from '../../styles/assets/onboarding-3.svg';

const mapActionCreators = {
  saveOnboard,
  runJoyride,
};

const mapStateToProps = state => ({
  login: state.login,
});

class OnboardingDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      member1Name: '',
      member1Email: '',
      member2Name: '',
      member2Email: '',
      slideIndex: 0,
      visible: true,
    };
  }

  save = () => {
    // console.log('saving the company', this.state);

    this.setState({
      newComment: '',
    });
  };

  checkSubmit = event => {
    if (event.keyCode === 13) {
      this.save();
    }
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);
  };

  clickNext = () => {
    if (this.state.slideIndex < 2) {
      this.setState({ slideIndex: this.state.slideIndex + 1 });
    } else {
      this.props.saveOnboard(this.state);
      this.setState({ visible: false });
      this.props.runJoyride();
    }
  };

  validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  validation = () => {
    const validation = {
      disabled: false,
      email1Valid: true,
      email2Valid: true,
      name1Valid: true,
      name2Valid: true,
    };

    if (this.state.slideIndex === 1 && this.state.name.length < 3) {
      validation.disabled = true;
    }

    if (this.state.slideIndex === 2) {
      if (this.state.member1Email.length) {
        if (!this.state.member1Name.length) {
          validation.disabled = true;
          validation.name1Valid = false;
        }
        if (!this.validateEmail(this.state.member1Email)) {
          validation.disabled = true;
          validation.email1Valid = false;
        }
      }
      if (this.state.member2Email.length) {
        if (!this.state.member2Name.length) {
          validation.disabled = true;
          validation.name2Valid = false;
        }
        if (!this.validateEmail(this.state.member2Email)) {
          validation.disabled = true;
          validation.email2Valid = false;
        }
      }
    }

    return validation;
  };

  render() {
    const props = this.props;

    if (
      typeof this.props.login === 'undefined' ||
      typeof this.props.login.onboardingDone === 'undefined'
    ) {
      return null;
    }

    if (
      this.props.login.onboardingDone > 0 ||
      this.props.login.amIAdmin !== true
    ) {
      return null;
    }

    const validation = this.validation();

    const actions = [
      <FlatButton
        label={this.state.slideIndex < 2 ? 'Weiter' : 'Schliessen'}
        primary
        disabled={validation.disabled}
        onMouseDown={this.clickNext}
      />,
    ];

    const dialogStyle = {
      width: '100%',
      maxWidth: '640px',
      textAlign: 'center',
    };

    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    return (
      <div>
        <Dialog
          actions={actions}
          modal
          open={this.state.visible}
          contentStyle={dialogStyle}
          autoScrollBodyContent
          onRequestClose={() => props.setTask(null)}
        >
          <SwipeableViews
            index={this.state.slideIndex}
            onChangeIndex={this.handleChange}
            className="swiper-swipeable-tabs"
            key="onboarding_swiper"
          >
            <div className={classes.swiperSlide}>
              <Slider {...sliderSettings}>
                <div>
                  <h2>Herzlich Willkommen zu SiMPL!</h2>
                  <div className={classes.onboarding}>
                    <img src={onboardingImage1} />
                  </div>
                  <p>
                    Mit SiMPL können Sie ganz einfach Ihre Kunden,
                    <br />
                    Dienstleister, Kontakte und Mitarbeiter verwalten.
                  </p>
                </div>
                <div>
                  <h2>Verwaltung ganz SiMPL</h2>
                  <div className={classes.onboarding}>
                    <img src={onboardingImage2} />
                  </div>
                  <p>
                    Erstellen Sie Projekte, Aktivitäten und
                    <br />
                    behalten Sie die Übersicht über alle Vorgänge in Ihrer
                    Firma.
                  </p>
                </div>
                <div>
                  <h2>Übersicht über alles</h2>
                  <div className={classes.onboarding}>
                    <img src={onboardingImage3} />
                  </div>
                  <p>
                    Mit Benachrichtigungen bleiben Sie immer auf dem neuesten
                    Stand und
                    <br />
                    erfahren, wenn sich etwas an Ihren Projekten ändert oder
                    eine Aufgabe erledigt wurde.
                  </p>
                </div>
              </Slider>
            </div>
            <div className={`flex-vcenter ${classes.textSlide}`}>
              <div className="row">
                <div className="col-xs-12 flex-vcenter">
                  {/* <label className="simpl-label" htmlFor="name"> */}
                  <h2>Wie heißt Ihr Unternehmen?</h2>
                  {/* </label> */}
                </div>
                <div className="col-xs-12 flex-vcenter">
                  <input
                    name="name"
                    value={this.state.name}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
            </div>
            <div className={`flex-vcenter ${classes.textSlide}`}>
              <h2>Mitarbeiter einladen</h2>

              <p>
                Laden Sie Ihre Mitarbeiter ein und arbeiten Sie gemeinsam an
                Projekten,
                <br />
                Aktivitäten und Aufgaben. Verwaltung ist ein Job für mehr als
                eine Person!
              </p>

              <div className="row">
                <div className="col-xs-12 col-md-7">
                  <label>Email</label>
                </div>
                <div className="col-xs-12 col-md-5">
                  <label>Name</label>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-md-7 flex-vcenter">
                  <input
                    type="email"
                    placeholder="max@mustermann.de"
                    name="member1Email"
                    value={this.state.member1Email}
                    onChange={e => this.handleChange(e)}
                    className={validation.email1Valid ? '' : classes.error}
                  />
                </div>
                <div className="col-xs-12 col-md-5 flex-vcenter">
                  <input
                    type="text"
                    placeholder="Max Mustermann"
                    name="member1Name"
                    value={this.state.member1Name}
                    onChange={e => this.handleChange(e)}
                    className={validation.name1Valid ? '' : classes.error}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-md-7 flex-vcenter">
                  <input
                    type="email"
                    placeholder="max@mustermann.de"
                    name="member2Email"
                    value={this.state.member2Email}
                    onChange={e => this.handleChange(e)}
                    className={validation.email2Valid ? '' : classes.error}
                  />
                </div>
                <div className="col-xs-12 col-md-5 flex-vcenter">
                  <input
                    type="text"
                    placeholder="Max Mustermann"
                    name="member2Name"
                    value={this.state.member2Name}
                    onChange={e => this.handleChange(e)}
                    className={validation.name2Valid ? '' : classes.error}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12">
                  <div className={classes.inviteInfo}>
                    {/* Um weitere Mitarbeiter zum Teilnehmen einzuladen, können Sie jederzeit<br/> */}
                    {/* ein Upgrade auf ein anderes Abo-Modell durchführen. */}
                    Sie können jederzeit unter dem Menüpunkt weitere Mitarbeiter
                    einladen,
                    <br />
                    wenn Sie in Ihrem Plan weitere Plätze frei haben.
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h2>Damit gehts auch schon los!</h2>
              <p>Viel Spaß mit SiMPL!</p>
            </div>
          </SwipeableViews>
        </Dialog>
      </div>
    );
  }
}
OnboardingDialog.propTypes = {
  saveOnboard: PropTypes.func.isRequired,
  runJoyride: PropTypes.func.isRequired,
  login: PropTypes.object,
};
OnboardingDialog.defaultProps = {
  user: {},
};
export default connect(mapStateToProps, mapActionCreators)(OnboardingDialog);



// WEBPACK FOOTER //
// ./src/components/OnboardingDialog/OnboardingDialog.js